// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Radio$OrcaPaymentPage from "./Radio.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as Surcharge$OrcaPaymentPage from "./Surcharge.bs.js";
import * as TestUtils$OrcaPaymentPage from "../Utilities/TestUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as DynamicFields$OrcaPaymentPage from "./DynamicFields.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "./PaymentInputField.bs.js";
import * as InstallmentOptions$OrcaPaymentPage from "./InstallmentOptions.bs.js";

function SavedCardItem$RenderSavedPaymentMethodItem(props) {
  var paymentMethodType = props.paymentMethodType;
  var paymentItem = props.paymentItem;
  var match = paymentItem.paymentMethod;
  switch (match) {
    case "bank_debit" :
        return React.createElement("div", {
                    "aria-label": paymentMethodType.toUpperCase() + " bank debit account ending in " + paymentItem.bank.mask,
                    className: "flex flex-col items-start",
                    role: "group"
                  }, React.createElement("div", undefined, paymentMethodType.toUpperCase() + " " + Utils$OrcaPaymentPage.snakeToTitleCase(paymentItem.paymentMethod)), React.createElement("div", {
                        className: "PickerItemLabel flex flex-row gap-3 items-center"
                      }, React.createElement("div", {
                            "aria-hidden": true,
                            className: "tracking-widest"
                          }, "****"), React.createElement("div", {
                            "aria-hidden": true
                          }, paymentItem.bank.mask)));
    case "card" :
        return React.createElement("div", {
                    "aria-label": "Card " + paymentItem.card.nickname + ", ending in " + paymentItem.card.last4Digits,
                    className: "flex flex-col items-start",
                    role: "group"
                  }, React.createElement("div", {
                        className: "text-base tracking-wide"
                      }, paymentItem.card.nickname.length > 15 ? paymentItem.card.nickname.slice(0, 13).concat("..") : paymentItem.card.nickname), React.createElement("div", {
                        className: "PickerItemLabel flex flex-row gap-3 items-center text-sm"
                      }, React.createElement("div", {
                            "aria-hidden": true,
                            className: "tracking-widest"
                          }, "****"), React.createElement("div", {
                            "aria-hidden": true,
                            className: "tracking-wide"
                          }, paymentItem.card.last4Digits)));
    default:
      return React.createElement("div", {
                  "aria-label": Utils$OrcaPaymentPage.snakeToTitleCase(paymentMethodType)
                }, Utils$OrcaPaymentPage.snakeToTitleCase(paymentMethodType));
  }
}

var RenderSavedPaymentMethodItem = {
  make: SavedCardItem$RenderSavedPaymentMethodItem
};

function SavedCardItem(props) {
  var eligibilitySurchargeDetails = props.eligibilitySurchargeDetails;
  var setShowInstallments = props.setShowInstallments;
  var setSelectedInstallmentPlan = props.setSelectedInstallmentPlan;
  var cvcProps = props.cvcProps;
  var paymentItem = props.paymentItem;
  var isActive = props.isActive;
  var setPaymentToken = props.setPaymentToken;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var config = match.config;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match$2 = CardUtils$OrcaPaymentPage.getLayoutClass(match$1.layout).savedMethodCustomization;
  var hideCardExpiry = match$2.hideCardExpiry;
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.cardBrand);
  var cvcError = cvcProps.cvcError;
  var handleCVCBlur = cvcProps.handleCVCBlur;
  var changeCVCNumber = cvcProps.changeCVCNumber;
  var cvcNumber = cvcProps.cvcNumber;
  var setIsCVCValid = cvcProps.setIsCVCValid;
  var isCVCValid = cvcProps.isCVCValid;
  var setCardBrand = match$3[1];
  var isCvcEmpty = cvcNumber.length === 0;
  var cvcRef = React.useRef(null);
  var pickerItemClass = isActive ? "PickerItem--selected" : "";
  var focusCVC = function () {
    setCardBrand(function (param) {
          var val = paymentItem.card.scheme;
          if (val !== undefined) {
            return val;
          } else {
            return "";
          }
        });
    var optionalRef = cvcRef.current;
    if (!(optionalRef == null)) {
      Core__Option.forEach((optionalRef == null) ? undefined : Caml_option.some(optionalRef), (function (input) {
              input.focus();
            }));
      return ;
    }
    
  };
  var isCard = paymentItem.paymentMethod === "card";
  var isRenderCvv = isCard && paymentItem.requiresCvv;
  var expiryMonth = paymentItem.card.expiryMonth;
  var expiryYear = paymentItem.card.expiryYear;
  var cardLast4 = paymentItem.card.last4Digits;
  var cardBin = paymentItem.card.cardBin;
  var paymentMethodType = paymentItem.paymentMethodType;
  var paymentMethodType$1 = paymentMethodType !== undefined ? paymentMethodType : "debit";
  var match$4 = PaymentUtils$OrcaPaymentPage.useNonPiiAddressData();
  var pinCode = match$4.pinCode;
  var state = match$4.state;
  var country = match$4.country;
  React.useEffect((function () {
          setSelectedInstallmentPlan(function (param) {
                
              });
          setShowInstallments(function (param) {
                return false;
              });
        }), [paymentItem]);
  React.useEffect((function () {
          if (isActive) {
            PaymentUtils$OrcaPaymentPage.emitPaymentMethodInfo(paymentItem.paymentMethod, paymentMethodType$1, CardUtils$OrcaPaymentPage.getCardType(Core__Option.getOr(paymentItem.card.scheme, "")), cardLast4, cardBin, expiryMonth, expiryYear, country, state, pinCode, true, isCvcEmpty);
          }
          
        }), [
        isActive,
        paymentItem,
        country,
        state,
        pinCode,
        isCvcEmpty
      ]);
  React.useEffect((function () {
          if (isActive) {
            focusCVC();
            CardUtils$OrcaPaymentPage.emitExpiryDate(CardValidations$OrcaPaymentPage.formatCardExpiryNumber(expiryMonth + expiryYear.substring(2, 4)));
          }
          
        }), [
        isActive,
        paymentItem,
        country,
        state,
        pinCode
      ]);
  React.useEffect((function () {
          CardUtils$OrcaPaymentPage.emitIsFormReadyForSubmission(Core__Option.getOr(isCVCValid, false));
        }), [isCVCValid]);
  var expiryDate = new Date(expiryYear + "-" + expiryMonth);
  expiryDate.setMonth(expiryDate.getMonth() + 1 | 0);
  var currentDate = new Date();
  var isCardExpired = isCard && Caml_obj.lessthan(expiryDate, currentDate);
  var billingDetailsArray = [
        paymentItem.billing.address.line1,
        paymentItem.billing.address.line2,
        paymentItem.billing.address.line3,
        paymentItem.billing.address.city,
        paymentItem.billing.address.state,
        paymentItem.billing.address.country,
        paymentItem.billing.address.zip
      ].map(function (item) {
          return Core__Option.getOr(item, "");
        }).filter(function (item) {
        return item.trim() !== "";
      });
  var billingDetailsArrayLength = billingDetailsArray.length;
  var isFloating = config.appearance.labels === "Floating";
  var cvcContainerClassName = isFloating ? "flex w-24" : "flex w-16 opacity-50";
  var cvcHeight = isFloating ? "" : "1.8rem";
  var cvcFieldName = isFloating ? localeString.cvcTextLabel : "";
  var makeCvcInput = function (fieldNameOpt, heightOpt, inputFieldClassNameOpt) {
    var fieldName = fieldNameOpt !== undefined ? fieldNameOpt : "";
    var height = heightOpt !== undefined ? heightOpt : "1.8rem";
    var inputFieldClassName = inputFieldClassNameOpt !== undefined ? inputFieldClassNameOpt : "flex justify-start";
    return React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                isValid: Caml_option.some(isCVCValid),
                setIsValid: setIsCVCValid,
                height: height,
                inputFieldClassName: inputFieldClassName,
                value: cvcNumber,
                onChange: changeCVCNumber,
                onBlur: handleCVCBlur,
                errorString: "",
                fieldName: fieldName,
                name: TestUtils$OrcaPaymentPage.cardCVVInputTestId,
                type_: "tel",
                maxLength: 4,
                placeholder: "123",
                className: "tracking-widest w-full",
                inputRef: cvcRef,
                autocomplete: "cc-csc"
              });
  };
  var match$5 = config.appearance;
  var innerLayout = match$5.innerLayout;
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var installmentOptions = Core__Option.getOr(paymentMethodListValue.intent_data.installment_options, []);
  var hasInstallmentPlans = PaymentUtils$OrcaPaymentPage.filterInstallmentPlansByPaymentMethod(installmentOptions, paymentItem.paymentMethod).length > 0;
  var surchargeAmount = Core__Option.getOr(Core__Option.map(eligibilitySurchargeDetails, (function (s) {
              return s.displayTotalSurchargeAmount.toString();
            })), "");
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: !match$1.hideExpiredPaymentMethods || !isCardExpired,
              children: React.createElement("button", {
                    className: "PickerItem " + pickerItemClass + " flex flex-row items-stretch",
                    style: {
                      background: "transparent",
                      borderTop: "none",
                      borderRight: "none",
                      borderBottom: props.index === (props.savedCardlength - 1 | 0) ? "0px" : "1px solid " + themeObj.borderColor,
                      borderLeft: "none",
                      color: themeObj.colorTextSecondary,
                      cursor: "pointer",
                      minWidth: "150px",
                      padding: "1rem 0 1rem 0",
                      width: "100%",
                      opacity: isCardExpired ? "0.7" : "1",
                      borderRadius: "0px",
                      boxShadow: "none"
                    },
                    type: "button",
                    onClick: (function (param) {
                        setPaymentToken(function (param) {
                              return {
                                      paymentToken: paymentItem.paymentToken,
                                      customerId: paymentItem.customerId
                                    };
                            });
                      })
                  }, React.createElement("div", {
                        className: "w-full"
                      }, React.createElement("div", undefined, React.createElement("div", {
                                className: "flex flex-row justify-between items-center"
                              }, React.createElement("div", {
                                    className: "flex flex-row justify-center items-center",
                                    style: {
                                      columnGap: themeObj.spacingUnit
                                    }
                                  }, React.createElement("div", {
                                        style: {
                                          color: isActive ? themeObj.colorPrimary : ""
                                        }
                                      }, React.createElement(Radio$OrcaPaymentPage.make, {
                                            checked: isActive,
                                            height: "18px",
                                            padding: "46%",
                                            className: "savedcard",
                                            marginTop: "-2px",
                                            opacity: "20%",
                                            border: "1px solid currentColor"
                                          })), React.createElement("div", {
                                        className: "PickerItemIcon mx-3 flex  items-center "
                                      }, props.brandIcon), React.createElement("div", {
                                        className: "flex flex-col"
                                      }, React.createElement("div", {
                                            className: "flex items-center gap-4"
                                          }, React.createElement(SavedCardItem$RenderSavedPaymentMethodItem, {
                                                paymentItem: paymentItem,
                                                paymentMethodType: paymentMethodType$1
                                              }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                                condition: match$1.displayDefaultSavedPaymentIcon && paymentItem.defaultPaymentMethodSet,
                                                children: React.createElement(Icon$OrcaPaymentPage.make, {
                                                      name: "checkmark",
                                                      size: 16,
                                                      style: {
                                                        color: themeObj.colorPrimary
                                                      }
                                                    })
                                              })))), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                    condition: isCard && !hideCardExpiry,
                                    children: React.createElement("div", {
                                          "aria-label": "Expires " + expiryMonth + " / " + CardUtils$OrcaPaymentPage.formatExpiryToTwoDigit(expiryYear),
                                          className: "flex flex-row items-center justify-end gap-3 -mt-1",
                                          style: {
                                            fontSize: "14px",
                                            opacity: "0.5"
                                          }
                                        }, React.createElement("div", {
                                              "aria-hidden": true,
                                              className: "flex"
                                            }, expiryMonth + " / " + CardUtils$OrcaPaymentPage.formatExpiryToTwoDigit(expiryYear)))
                                  }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                    condition: hideCardExpiry && isActive && isRenderCvv,
                                    children: React.createElement("div", {
                                          className: "flex flex-row items-center gap-2 mr-2"
                                        }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                                              condition: !isFloating,
                                              children: React.createElement("div", {
                                                    className: "tracking-widest opacity-50"
                                                  }, localeString.cvcTextLabel + ":")
                                            }), React.createElement("div", {
                                              className: cvcContainerClassName
                                            }, makeCvcInput(cvcFieldName, cvcHeight, "")))
                                  })), React.createElement("div", {
                                className: "w-full"
                              }, React.createElement("div", {
                                    className: "flex flex-col items-start ml-8"
                                  }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                                        condition: !hideCardExpiry && isActive && isRenderCvv,
                                        children: React.createElement("div", {
                                              className: "flex flex-row items-start justify-start gap-2",
                                              style: {
                                                fontSize: "14px",
                                                opacity: "0.5"
                                              }
                                            }, React.createElement("div", {
                                                  className: "tracking-widest w-12 mt-6"
                                                }, localeString.cvcTextLabel + ": "), React.createElement("div", {
                                                  className: "flex h mx-4 justify-start w-16 " + (
                                                    isActive ? "opacity-1 mt-4" : "opacity-0"
                                                  )
                                                }, makeCvcInput(undefined, undefined, undefined)))
                                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                        condition: hideCardExpiry && isActive && innerLayout === "Spaced" && cvcError !== "",
                                        children: React.createElement("div", {
                                              className: "Error pt-1 mt-1 ml-3",
                                              style: {
                                                color: themeObj.colorDangerText,
                                                fontSize: themeObj.fontSizeSm
                                              }
                                            }, cvcError)
                                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                        condition: isActive && match$1.displayBillingDetails && billingDetailsArrayLength > 0,
                                        children: React.createElement("div", {
                                              className: "tracking-wide text-sm text-left gap-2 mt-4 ml-2"
                                            }, React.createElement("div", {
                                                  className: "font-semibold"
                                                }, "Billing Details:"), React.createElement("div", {
                                                  className: "font-normal"
                                                }, billingDetailsArray.join(", ")))
                                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                        condition: !hideCardExpiry && isActive && innerLayout === "Spaced" && cvcError !== "",
                                        children: React.createElement("div", {
                                              className: "Error pt-1 mt-1 ml-1",
                                              style: {
                                                color: themeObj.colorDangerText,
                                                fontSize: themeObj.fontSizeSm
                                              }
                                            }, cvcError)
                                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                        condition: isCardExpired,
                                        children: React.createElement("div", {
                                              className: "italic mt-3 ml-1",
                                              style: {
                                                fontSize: "14px",
                                                opacity: "0.7"
                                              }
                                            }, "*" + localeString.cardExpiredText)
                                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                        condition: isActive,
                                        children: null
                                      }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                                            condition: isCard && hasInstallmentPlans,
                                            children: React.createElement("div", {
                                                  className: "w-full flex pl-1",
                                                  style: {
                                                    paddingTop: themeObj.spacingUnit
                                                  }
                                                }, React.createElement(InstallmentOptions$OrcaPaymentPage.make, {
                                                      setSelectedInstallmentPlan: setSelectedInstallmentPlan,
                                                      showInstallments: props.showInstallments,
                                                      setShowInstallments: setShowInstallments,
                                                      paymentMethod: paymentItem.paymentMethod,
                                                      errorString: props.installmentsError,
                                                      setErrorString: props.setInstallmentsError
                                                    }))
                                          }), React.createElement(DynamicFields$OrcaPaymentPage.make, {
                                            paymentMethod: paymentItem.paymentMethod,
                                            paymentMethodType: paymentMethodType$1,
                                            setRequiredFieldsBody: props.setRequiredFieldsBody,
                                            isSavedCardFlow: true,
                                            savedMethod: paymentItem
                                          }), React.createElement(Surcharge$OrcaPaymentPage.make, {
                                            paymentMethod: paymentItem.paymentMethod,
                                            paymentMethodType: paymentMethodType$1,
                                            cardBrand: CardUtils$OrcaPaymentPage.getCardType(match$3[0])
                                          }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                            condition: Core__Option.isSome(eligibilitySurchargeDetails) && isCard,
                                            children: React.createElement("div", {
                                                  className: "flex items-baseline text-xs mt-2 ml-1"
                                                }, React.createElement(Icon$OrcaPaymentPage.make, {
                                                      name: "asterisk",
                                                      size: 8,
                                                      className: "text-red-600 mr-1"
                                                    }), React.createElement("div", {
                                                      className: "text-left text-gray-400"
                                                    }, localeString.surchargeMsgAmountForCard(paymentMethodListValue.currency, surchargeAmount)))
                                          })))))))
            });
}

var make = SavedCardItem;

export {
  RenderSavedPaymentMethodItem ,
  make ,
}
/* react Not a pure module */
